import { Box } from '@ltvco/refresh-lib/theme';
import { TypingIndicator, Message } from '@ltvco/refresh-lib/v2';
import { MessageContent } from './MessageContent/MessageContent';
import { baseMessageBoxContainerStyles } from '../components/ChatPage/components/MessagesContainer';

interface AssistantSectionProps {
  assistant: Message | null;
  assistantIndex: number | null;
  isLastPair: boolean;
  hasUserScrolled: boolean;
  loadingStatus: { message: string; subtitle: string };
  firstPhotoDamageAssistantIndex: number;
  onMessageRef: (index: number, element: HTMLDivElement | null) => void;
  onTypingRef: (element: HTMLDivElement | null) => void;
  onGapRef: (element: HTMLDivElement | null) => void;
  tailGap: number;
}

export const AssistantSection = ({
  assistant,
  assistantIndex,
  isLastPair,
  hasUserScrolled,
  loadingStatus,
  firstPhotoDamageAssistantIndex,
  onMessageRef,
  onTypingRef,
  onGapRef,
  tailGap,
}: AssistantSectionProps) => {
  // First assistant message is rendered as a dedicated damage analyzer card
  // so we skip the standard assistant bubble here.
  if (
    assistantIndex !== null &&
    assistantIndex === firstPhotoDamageAssistantIndex
  ) {
    return null;
  }

  if (assistant) {
    return (
      <>
        <Box
          ref={(el: HTMLDivElement | null) => {
            if (assistantIndex !== null) {
              onMessageRef(assistantIndex, el);
            }
          }}
          sx={baseMessageBoxContainerStyles}
        >
          <MessageContent
            content={assistant.content || 'Result'}
            isHeader={false}
            isSticky={false}
            hasUserScrolled={hasUserScrolled}
          />
        </Box>
        {isLastPair && tailGap > 0 && (
          <Box ref={onGapRef} sx={{ height: `${tailGap}px`, width: '100%' }} />
        )}
      </>
    );
  }

  return (
    <>
      <Box ref={onTypingRef} sx={{ width: '100%', maxWidth: '740px' }}>
        <TypingIndicator loadingStatus={loadingStatus} />
      </Box>
      {isLastPair && tailGap > 0 && (
        <Box ref={onGapRef} sx={{ height: `${tailGap}px`, width: '100%' }} />
      )}
    </>
  );
};
